export default __webpack_public_path__ + "static/media/Export-Reorder-active.edc540c1.svg";